<template>
  <navbar navbar-menu-classes="navbar-center">
    <template slot="navbar-menu">
      <router-link to="/" class="nav-item" tag="li">
        <a class="nav-link"> <i class="nc-icon nc-book-bookmark"></i> Home </a>
      </router-link>
      <router-link to="/account/login" class="nav-item" tag="li">
        <a class="nav-link"> <i class="nc-icon nc-tap-01"></i> Login </a>
      </router-link>
    </template>
  </navbar>
</template>

<script>
import { Navbar } from "@/components/UIComponents";
export default {
  name: "main-navbar",
  components: {
    Navbar
  }
};
</script>

<style scoped></style>
